(() => {
  let controller;
  function initialize() {
  controller?.abort();
  controller = new AbortController();
  const listen = (target,type,handler) => target.addEventListener(type,handler,{signal:controller.signal});
  const configElement = document.getElementById('HMClientConfig');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  config.root = config.root.endsWith('/') ? config.root : `${config.root}/`;
  const key = 'horizon-shopify-saved-v1';
  const dialog = document.querySelector('[data-hm-saved-dialog]');
  const productTitle = document.querySelector('.product__info-container .product__title');
  if (config.productHandle && productTitle && !document.querySelector('[data-hm-product-save]')) {
    const button = document.createElement('button'); button.type = 'button';
    button.className = 'hm-product-save'; button.dataset.hmSave = config.productHandle;
    button.dataset.hmProductSave = ''; button.setAttribute('aria-pressed','false');
    button.setAttribute('aria-label',`${config.save}: ${config.productTitle}`);
    const image = document.createElement('img'); image.src = config.heartIcon;
    image.alt = ''; image.width = 18; image.height = 18;
    const label = document.createElement('span'); label.textContent = config.save;
    button.append(image,label); productTitle.insertAdjacentElement('afterend',button);
  }
  let saved = [];
  try {
    const stored = JSON.parse(localStorage.getItem(key) || '[]');
    if (Array.isArray(stored)) saved = [...new Set(stored.filter(h => typeof h === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(h)))];
  } catch {}
  let toastTimer;
  const toast = message => {
    const target = document.querySelector('[data-hm-toast]');
    target.textContent = message;
    target.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => target.hidden = true, 4000);
  };
  function refreshSaved() {
    document.querySelectorAll('[data-hm-save]').forEach(button => {
      button.setAttribute('aria-pressed', String(saved.includes(button.dataset.hmSave)));
      button.title = saved.includes(button.dataset.hmSave) ? config.remove : config.save;
    });
  }
  async function renderSaved() {
    const root = document.querySelector('[data-hm-saved-content]');
    root.replaceChildren();
    if (!saved.length) { root.textContent = config.empty; return; }
    const requested = saved.slice();
    const rows = await Promise.all(requested.map(async handle => {
      const row = document.createElement('div'); row.className = 'hm-saved-row';
      try {
        const response = await fetch(`${config.root}products/${encodeURIComponent(handle)}.js`);
        if (!response.ok) throw new Error('Unavailable');
        const product = await response.json();
        const link = document.createElement('a');
        link.href = `${config.root}products/${encodeURIComponent(handle)}`;
        if (product.featured_image) {
          const image = document.createElement('img'); image.src = product.featured_image;
          image.alt = product.title; image.width = 65; image.height = 70; link.append(image);
        }
        const title = document.createElement('span'); title.textContent = product.title; link.append(title);
        row.append(link);
      } catch { const label = document.createElement('span'); label.textContent = config.unavailable; row.append(label); }
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = config.remove;
      remove.dataset.hmSave = handle; remove.className = 'hm-text-link'; row.append(remove); return row;
    }));
    if (requested.join('|') !== saved.join('|')) return;
    root.replaceChildren(...rows);
    refreshSaved();
  }
  listen(document,'click', event => {
    const save = event.target.closest('[data-hm-save]');
    if (save) {
      const handle = save.dataset.hmSave;
      if (!/^[a-z0-9][a-z0-9-]*$/.test(handle)) return;
      const exists = saved.includes(handle);
      saved = exists ? saved.filter(h => h !== handle) : [...saved, handle];
      try { localStorage.setItem(key, JSON.stringify(saved)); toast(exists ? config.removed : config.saved); }
      catch { toast(config.storage); }
      refreshSaved(); if (dialog.open) renderSaved();
    }
    if (event.target.closest('[data-hm-saved-open]')) {
      event.preventDefault(); if (!dialog.open) dialog.showModal(); renderSaved();
    }
    if (event.target.closest('[data-hm-saved-close]')) dialog.close();
  });
  document.querySelectorAll('[data-hm-header]').forEach(header => {
    const search = header.querySelector('[data-hm-search-panel]');
    const menu = header.querySelector('[data-hm-menu-panel]');
    const searchButton = header.querySelector('[data-hm-search-open]');
    const menuButton = header.querySelector('[data-hm-menu-open]');
    const setMenu = open => { menu.hidden = !open; menuButton.setAttribute('aria-expanded', String(open)); };
    const setSearch = open => { search.hidden = !open; searchButton.setAttribute('aria-expanded', String(open)); };
    listen(searchButton,'click', () => { const open = search.hidden; setMenu(false); setSearch(open); if (open) search.querySelector('input[type="search"]').focus(); });
    listen(menuButton,'click', () => { const open = menu.hidden; setSearch(false); setMenu(open); });
    listen(header.querySelector('[data-hm-search-close]'),'click', () => { setSearch(false); searchButton.focus(); });
    listen(menu,'click', event => { if (event.target.closest('a')) setMenu(false); });
    listen(document,'keydown', event => {
      if (event.key !== 'Escape') return;
      if (!search.hidden) { setSearch(false); searchButton.focus(); }
      if (!menu.hidden) { setMenu(false); menuButton.focus(); }
    });
  });
  document.querySelectorAll('[data-hm-shelf]').forEach(shelf => {
    shelf.querySelectorAll('[data-hm-filter]').forEach(button => listen(button,'click', () => {
      shelf.querySelectorAll('[data-hm-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      shelf.querySelectorAll('[data-hm-group]').forEach(group => group.hidden = group.dataset.hmGroup !== button.dataset.hmFilter);
      shelf.querySelector('[data-hm-filter-status]').textContent = button.textContent;
    }));
  });
  const openStory = () => { if (location.hash === '#hm-story') { const story = document.getElementById('hm-story'); if (story) story.open = true; } };
  listen(window,'hashchange', openStory); openStory(); refreshSaved();
  const assistant = document.querySelector('[data-hm-assistant]');
  const assistantOpen = document.querySelector('[data-hm-assistant-open]');
  const messages = document.querySelector('[data-hm-messages]');
  const messageInput = document.querySelector('[data-hm-message]');
  const toggleAssistant = open => {
    assistant.hidden = !open; assistantOpen.setAttribute('aria-expanded', String(open));
    if (open) messageInput.focus(); else assistantOpen.focus();
  };
  listen(assistantOpen,'click', () => toggleAssistant(assistant.hidden));
  listen(document.querySelector('[data-hm-assistant-close]'),'click', () => toggleAssistant(false));
  listen(document,'keydown', event => { if (event.key === 'Escape' && !assistant.hidden) toggleAssistant(false); });
  function message(text, customer = false, links = []) {
    const row = document.createElement('div'); row.className = `hm-message ${customer ? 'hm-customer' : 'hm-bot'}`;
    const copy = document.createElement('div'); copy.textContent = text; row.append(copy);
    links.forEach(({title,url}) => { const link = document.createElement('a'); link.textContent = title; link.href = url; row.append(link); });
    messages.append(row); messages.scrollTop = messages.scrollHeight;
  }
  const supportLink = {title:config.supportEmail,url:`mailto:${config.supportEmail}`};
  async function reply(input, intent = '') {
    const text = input.toLowerCase();
    if (intent === 'find' || /^(find products|products|categories|departments)$/.test(text)) {
      const links = [...document.querySelectorAll('.hm-collection')].map(link => ({title:link.querySelector('h3').textContent,url:link.href}));
      if (!links.length) links.push({title:document.querySelector('.hm-nav a').textContent,url:config.shopUrl});
      message(config.assistant.categories, false, links); return;
    }
    if (intent === 'shipping' || /shipping|deliver|track|where.*order|address|zip/.test(text)) { message(config.assistant.delivery,false,[{title:input,url:config.shippingUrl}]); return; }
    if (intent === 'returns' || /return|refund|damag|complaint|grievance|wrong item/.test(text)) { message(config.assistant.returns,false,[supportLink]); return; }
    if (intent === 'contact' || /contact|support|mail|phone|human/.test(text)) { message(config.assistant.support,false,[supportLink]); return; }
    if (/login|log in|sign.?in|sign.?up|account/.test(text)) { message(config.assistant.account,false,[{title:input,url:config.accountUrl}]); return; }
    const query = text.replace(/\b(do you have|in stock|stock|available|looking for|find|show me|price|cost|how much|please|a|an|the|is|are|of|what|can|you|me)\b/g,' ').trim();
    if (!query) { message(config.assistant.notFound,false,[supportLink]); return; }
    try {
      const url = new URL(`${config.root}search/suggest.json`,location.origin);
      url.searchParams.set('q',query); url.searchParams.set('resources[type]','product'); url.searchParams.set('resources[limit]','3');
      const response = await fetch(url); if (!response.ok) throw new Error('Search unavailable');
      const data = await response.json();
      const products = (data.resources?.results?.products || []).filter(product => /^[a-z0-9][a-z0-9-]*$/.test(product.handle));
      if (!products.length) { message(config.assistant.notFound,false,[supportLink]); return; }
      message(config.assistant.found,false,products.map(product => ({title:product.title,url:`${config.root}products/${encodeURIComponent(product.handle)}`})));
    } catch { message(config.assistant.error,false,[supportLink]); }
  }
  listen(document.querySelector('[data-hm-assistant-form]'),'submit',event => {
    event.preventDefault(); const text = messageInput.value.trim(); if (!text) return;
    message(text,true); messageInput.value = ''; reply(text);
  });
  document.querySelectorAll('[data-hm-prompt]').forEach(button => listen(button,'click',() => { message(button.textContent,true); reply(button.textContent,button.dataset.hmPrompt); }));
  }
  initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
